import {Component, Input} from '@angular/core';
import {ItemModuleDto} from '../../../../Models/Module/module.interface';
import {YuColorDto} from 'yukit';

@Component({
  selector: 'app-module-button',
  templateUrl: './module-button.component.html',
  styleUrls: ['./module-button.component.scss'],
  standalone: false
})
export class ModuleButtonComponent {
  @Input() item!: ItemModuleDto;
  @Input() icon: string = '';
  @Input() colorIcon: YuColorDto = 'success';
}
